var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-loading"},[_c('van-loading',{attrs:{"size":"24px","vertical":"","type":"spinner","color":"#1989fa"}},[_vm._v("正在进入预览模式...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }